import { useNavigate } from 'react-router-dom';
import logo from '../../../../assets/images/svg/viettel-media.svg';
import { URL } from '../../../../routers/constants';

const Logo = () => {
   const navigate = useNavigate();

   const redirectHome = () => {
      navigate(URL.HOME);
   }
   return (
      <div className="header-logo cursor-pointer" onClick={redirectHome}>
         <img src={logo} />
      </div>
   )
}

export default Logo;